<template>
  <div>
    <el-page-header class="detail-head" @back="goBack" content="用户地址详情"> </el-page-header>
    <el-divider></el-divider>
    <div class="detail-container">
      <el-scrollbar>
        <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="用户名称" class="detail-form-item">
                  <el-input size="medium" v-model="entity.user.realName" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="联系人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.contactPerson"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="联系方式" class="detail-form-item">
                  <el-input size="medium" v-model="entity.phone"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="是否默认" class="detail-form-item">
                  <el-radio-group v-model="entity.default">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="所在地区" class="detail-form-item">
                  <el-cascader ref="casRegions" :props="regionProps" v-model="entity.region" :options="regions"></el-cascader>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="详细地址" class="detail-form-item">
                  <el-input size="medium" v-model="entity.detail"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item label="完整地址" class="detail-form-item">
                  <el-input size="medium" v-model="entity.fullAddress"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.creator" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="创建时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改人" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content">
                <el-form-item label="修改时间" class="detail-form-item">
                  <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content">
                <el-form-item label="备注" class="detail-form-item">
                  <el-input type="textarea" v-model="entity.remark"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </el-scrollbar>
    </div>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Address } from "@/script/apps/user/entity/UserEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import addressList from "@/script/core/util/Address";
import { AddressService } from "@/script/apps/user/service/AddressService";
import { ElMessage } from "element-plus";
import { Watch } from "vue-property-decorator";

@Options({})
export default class AddressDetail extends BaseDetail {
  private service = new AddressService();

  private regionProps = { value: "code", label: "name" };

  private regions = addressList;

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_user_address",
      "/user/address",
      "/user/address",
      this.service
    );
    data.entity = { user: { realName: "" } };
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Address = {};
    return entity;
  }

  public afterLoad(data: any) {
    const address = data as Address;
    address.region = [];
    address.region.push(address.province!);
    address.region.push(address.city!);
    address.region.push(address.county!);
  }

  public beforeSave() {
    const address = this.entity as Address;
    address.province = this.entity.region[0];
    address.city = this.entity.region[1];
    address.county = this.entity.region[2];
    return true;
  }

  @Watch("entity.detail")
  private onDetailChanged(newVal: string, oldVal: string): void {
    this.updateFullAddress();
  }

  @Watch("entity.region")
  private onRegionChanged(newVal: string, oldVal: string): void {
    this.updateFullAddress();
  }

  private updateFullAddress() {
    const address = this.entity as Address;
    const nodes = (this.$refs.casRegions as any).getCheckedNodes();
    if (nodes.length > 0) {
      address.fullAddress = nodes[0].pathLabels.join("") + address.detail;
    }
  }
}
</script>

<style lang="scss">
</style>
